import get from 'transmute/get';
import getIn from 'transmute/getIn';
export const getLabelFromStage = get('label');
export const getIdFromStage = get('stageId');
export const getPropertyValueRequirementsFromStage = get('propertyValueRequirements');
export const getStageIsClosed = stage => {
  const isClosed = getIn(['metadata', 'isClosed'], stage); // returns a string value
  if (isClosed === 'false') return false;
  return true;
};